/**
 * Whether the page was drawn for somebody signed in.
 *
 * `head/session-state.html` puts `data-cb-session` on `<html>` from the
 * `__Host-session-hint` cookie before the page is painted, which is the only
 * thing a page cached at the edge has to go on. See "How a cached page knows"
 * in docs/user-features.md.
 *
 * **A hint can be stale and nothing here should be a lock.** A session ended
 * from another device leaves the cookie where it is, so this can say yes for
 * somebody the handler would refuse. Everything in the tools that asks either
 * offers something or holds something back, and the worst a stale yes costs is
 * a request that answers with nothing.
 */
export function readerSignedIn(page: Document): boolean {
  return page.documentElement.dataset["cbSession"] === "in";
}
